export const registerAcc = async (username, password, role) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("ngrok-skip-browser-warning", "69420");
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify({
    username: username,
    password: password,
    role: role,
    site: localStorage.getItem("site-redeem"),
  });

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(localStorage.getItem("endpoint-redeem") + "/account/register?site=" + localStorage.getItem("site-redeem"), requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const getAcc = async () => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("ngrok-skip-browser-warning", "69420");

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(localStorage.getItem("endpoint-redeem") + "/account?site=" + localStorage.getItem("site-redeem"), requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const updatePassAcc = (username, password) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ngrok-skip-browser-warning", "69420");

  let raw = JSON.stringify({
    username: username,
    password: password,
  });

  let requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(localStorage.getItem("endpoint-redeem") + "/account?site=" + localStorage.getItem("site-redeem"), requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const updateRoleAcc = (username, role) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ngrok-skip-browser-warning", "69420");

  let raw = JSON.stringify({
    username: username,
    role: role,
  });

  let requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(localStorage.getItem("endpoint-redeem") + "/account?site=" + localStorage.getItem("site-redeem"), requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const removeAcc = (username) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("ngrok-skip-browser-warning", "69420");

  let requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(localStorage.getItem("endpoint-redeem") + "/account?site=" + localStorage.getItem("site-redeem") + "&username=" + username, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};
